module.exports = __webpack_public_path__ + "81d5fe49e3faa206b3755d5d3643f05a.png";